module.exports = require('./socket');
/**
 * Exports parser
 *
 * @api public
 *
 */

module.exports.parser = require('engine.io-parser');